import accountmanagement from './accountmanagement2.png'
import creative from './creative2.png'

import ecmedia from './ecmedia2.png'
import edge from './edge2.png'
import investment from './investment2.png'
import mediaplanning from './mediaplanning2.png'
import performanceplanner from './performanceplanner2.png'
import feeds from './feeds2.png'
import planning from './planning2.png'

export default {
  'd&tprojectmanagement': edge,
  'd&tproductoperations': edge,
  'd&tconsulting': edge,
  analytics: edge,
  growthplanning: edge,
  edge,
  feeds,
  ecmedia,
  mediaplanning,
  performanceplanner,
  investment,
  creative,
  praccountmanagement: accountmanagement,
  accountmanagement,
  planning,
}
